var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgParkingP4B = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 349.995,
  height: 333.331,
  viewBox: "0 0 349.995 333.331"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "parking_P4B_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 249.998h262.496V0H0z"
})))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0072ce",
  d: "m0 0 .01 333.33h349.985V0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#parking_P4B_svg__a)",
  transform: "matrix(1.33333 0 0 -1.33333 0 333.33)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M204.147 41.804h-8.454V68.3h7.972c9.403 0 13.22-5.7 13.22-13.25 0-8.05-4.527-13.246-12.738-13.246m-8.454 62.645h7.5c7.26 0 12.263-4.337 12.263-11.64 0-7.06-4.404-12.875-11.903-12.875h-7.86zm20.713-29.84v.25c5.473 2.104 13.803 6.19 13.803 19.932 0 14.607-7.854 21.296-25 21.296h-24.276V29.67h25.356c14.756 0 25.83 8.543 25.83 24.268 0 14.483-9.287 19.19-15.714 20.674M139.57 60.416H118.4l20.93 37.41h.24zm16.213 55.433H134.73l-31.58-54.324v-13.95h36.42V29.67h16.214v17.905h10.762v12.84h-10.76zM81.52 157.17h-9.645v41.958h9.645c14.185 0 26.194-5.513 26.194-21.47 0-15.955-12.404-20.488-26.194-20.488m54.958 22.062c0 32.9-27.382 41.57-57.328 41.57H44.282v-137.5h27.59v52.195h11.61c29.554 0 52.994 11.626 52.994 43.734"
}))));
export default SvgParkingP4B;